import { api } from "@/modules/api";
import type { AgentIntentGraph } from "@/pages/agent/intent-graph/agent-intent-graph.types";

export const getAgentIntentGraph = async (): Promise<AgentIntentGraph> => {
  const response = await api.get("/v2/mem-agent-intent-graph");

  if (response.error || !response.data) {
    throw new Error("Unable to load Mem's information and intent model");
  }

  return response.data;
};
